import { useParams, useSearchParams } from 'react-router-dom';
import { useAlgoliaAppContext } from '../hooks/useAlgoliaAppContext';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
import { useHierarchyContext } from '../hooks/useHierarchyContext';
import { collectionData, queryLetter } from '../configs';
import { useSEOKeywords } from '../hooks/useSEOKeywords';
const headTitles = document.querySelectorAll('head title');
const metaTitles = document.querySelectorAll('head meta[property="og:title"], head meta[name="twitter:title"]');
const metaDescriptions = document.querySelectorAll('head meta[name="description"], head meta[property="og:description"], head meta[name="twitter:description"]');
export const SEOMetaData = () => {
    const { pagePath } = useAlgoliaAppContext();
    const { handle } = useParams();
    const { objects } = useHierarchyContext();
    const { kw1, kw2, layoutKey, mediumKey } = useSEOKeywords();
    const { nbHits } = useAlgoliaDataContext();
    const [searchParams] = useSearchParams();
    const colObject = objects?.[handle ?? ''];
    let title = pagePath === 'search'
        ? searchParams.get(queryLetter) ?? 'Search'
        : colObject?.name ?? collectionData.title;
    title = title[0].toUpperCase() + title.slice(1);
    const titleKw2 = mediumKey === 'noMedium' && layoutKey === 'noLayout'
        ? 'Paintings, Drawings & Photograph Art Prints'
        : layoutKey === 'noLayout'
            ? 'Prints, Framed Prints And Multi Panel Art'
            : kw2;
    const metaTitleContent = `${title} ${kw1} | ${titleKw2}`;
    headTitles.forEach(t => {
        t.textContent = metaTitleContent;
    });
    metaTitles.forEach(t => {
        t.setAttribute('content', metaTitleContent);
    });
    const metaDescription = layoutKey === 'noLayout'
        ? `Select from ${nbHits} curated ${title} ${kw1}, including ${title} prints, framed prints and multi panel art. Now on a special 60% discount & free returns`
        : `Select from ${nbHits} curated ${title} ${kw1}. Enjoy free returns and a special 60% discount on all our ${title} ${kw2}`;
    metaDescriptions.forEach(d => {
        d.setAttribute('content', metaDescription);
    });
    return null;
};
